import slice from "./revenueSlice";

export default slice.reducer;
